import { useState, type ReactNode } from "react";

import { ApiError } from "@/api/client";

/** Standard mutation error feedback (U11): ApiError unwrap + a ready-to-place
 *  error node. Was the hand-rolled `setErr` + red-span pattern ×4. */
export function useMutationFeedback(): {
  err: string;
  /** wire to useMutation onError */
  fail: (e: unknown) => void;
  /** wire to useMutation onSuccess (clears the error) */
  ok: () => void;
  /** render this where the error should appear (null when none) */
  errorNode: ReactNode;
} {
  const [err, setErr] = useState("");
  return {
    err,
    fail: (e: unknown) => setErr(e instanceof ApiError
      ? [e.message || e.code, ...(e.detail?.errors ?? [])].join(" · ")
      : String(e)),
    ok: () => setErr(""),
    errorNode: err ? <span style={{ color: "var(--bad)", fontSize: 12 }}>{err}</span> : null,
  };
}
